// extracted by css-extract-rspack-plugin
module.exports =  {"root":"f1edfbfa30","header":"fcc3d1f0f6","centered":"d9b1fec292","markerHolder":"d74d4701c3","list":"bca464a71d","content":"f5acfda401","item":"f7b87a83b3","icon":"e3877da497"};